/** auth refresh 레이어를 타면 안 되는 경로 — 로그인·OTP·공개 조회 등 */
const ANONYMOUS_PATH_PATTERNS = [
    /^\/auth\/signup\//,
    /^\/auth\/login(?:\/|$)/,
    /^\/auth\/logout$/,
    /^\/auth\/providers$/,
    /^\/terms\/current$/,
    /^\/terms\/[^/]+\/versions$/,
    /^\/terms\/documents\/[^/]+$/,
];
function toPathString(input) {
    if (typeof input === 'string')
        return input;
    if (input instanceof URL)
        return `${input.pathname}${input.search}`;
    return input.url;
}
function isAnonymousPath(path) {
    const pathname = path.split('?')[0] ?? path;
    return ANONYMOUS_PATH_PATTERNS.some((pattern) => pattern.test(pathname));
}
/**
 * JSON이 아닌 응답에서 빈 본문을 `undefined`로 맞춘다.
 * 비비즈니스 에러는 status만 있고 body가 없다.
 */
export async function readEmptyableBody(res) {
    const text = await res.text();
    return text.length === 0 ? undefined : text;
}
export function createBackendFetcher(authClient) {
    return (input, init) => {
        const path = toPathString(input);
        const fetcher = isAnonymousPath(path) ? authClient.fetchPublic : authClient.fetch;
        return fetcher(input, init);
    };
}
export function toTsRestApi(fetcher) {
    return async ({ path, method, headers, body }) => {
        const res = await fetcher(path, {
            method,
            headers,
            body,
            credentials: 'include',
        });
        const contentType = res.headers.get('content-type');
        // 비비즈니스 에러는 JSON이 없다. 빈 본문을 문자열로 남기면 호출부가 계약을 오해한다.
        const parsedBody = contentType?.includes('json')
            ? await res.json()
            : await readEmptyableBody(res);
        return { status: res.status, body: parsedBody, headers: res.headers };
    };
}
//# sourceMappingURL=backend-fetcher.js.map